import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { IRecordListItem, RecordListItem } from "./recordListItem";
import { IRecordFurtherEducationGroupNode } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNode";
import { RecordListItemUserQualification } from "ui/Scripts/source/models/recordUserQualification/recordListItemUserQualification";
import { IRecordCompanyFurtherEducationGroups, RecordCompanyFurtherEducationGroups } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/recordFurtherEducationGroup/recordCompanyFurtherEducationGroups";

export interface IRecordListItems extends ListItems<IRecordListItem> {
    companyFurtherEducationGroups: IRecordCompanyFurtherEducationGroups[];
    initializeQualifications(furtherEducationGroups: IRecordFurtherEducationGroupNode[]);
}

export class RecordListItems extends ListItems<RecordListItem> implements IRecordListItems {
    companyFurtherEducationGroups: RecordCompanyFurtherEducationGroups[];

    constructor();
    constructor(obj: IRecordListItems);
    constructor(obj?: any) {
        super(obj);
        this.companyFurtherEducationGroups = Base.getTypedArray(obj ? obj.companyFurtherEducationGroups : null, RecordCompanyFurtherEducationGroups);
        this.items = Base.getTypedArray(obj ? obj.items : null, RecordListItem);
    }

    initializeQualifications() {
        if (!this.companyFurtherEducationGroups || this.companyFurtherEducationGroups.length < 1) return;
        for (const item of this.items) {
            const furtherEducationGroups = this.companyFurtherEducationGroups.find((c) => c.companyId === item.userCompanyId)?.furtherEducationGroups;
            if (!furtherEducationGroups || furtherEducationGroups.length < 1) continue;
            // eslint-disable-next-line no-undef
            RecordListItemUserQualification.setFurtherEducationCodesAndValidity(item.qualifications, furtherEducationGroups, item.furtherEducations);
        }
    }
}